import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const id = "firstFunction6";
const idPrev = "firstFunction5";

const prev = `
functions:
  - function: Duel
    parameters:
      - parameter: Protagonist
        choices:
          - choice: Peter
          - choice: Edmund
          - choice: Susan
      - parameter: Antagonist
      - parameter: Weapon
      - parameter: Location
`;

function ManualFirstFunction6({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("show-generator-1") && (
        <div className={`${styles["container"]} ${styles["container-ff6"]} ${styles["overlay"]}`}>
          <div
            id="tutorial-text-5"
            className={`${styles["container__text"]} ${styles["container__text-1"]}`}>
            <p>Click here to generate your first test cases</p>
          </div>

          <Xarrow
            key={`arrow-4-${renderTrigger}`}
            start="tutorial-text-5"
            end="show-generator-1"
            color="#415B32"
            strokeWidth={3}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-ff6"]} ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Nice work! Your model is now fully functional. Ready to see it in action? Click the
              'Generate Tests' button at the bottom of the screen.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
        </div>
      </div>
    </>
  );
}

export default ManualFirstFunction6;
